import { useCallback, useState } from 'react';

/**
 * A hook that allows you to set a single boolean value at a time.
 * @param {boolean} initialState The initial state of the boolean.
 * @returns {[boolean, () => void, () => void]} A tuple containing the boolean, the setTrue function, and the setFalse function.
 * @example const [isLoading, setStartLoading, setStopLoading] = useBinaryState();
 */
export const useBinaryState = (initialState = false) => {
  const [state, setState] = useState(initialState);

  const setTrue = useCallback(() => setState(true), []);

  const setFalse = useCallback(() => setState(false), []);

  return [state, setTrue, setFalse];
};
